var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon39(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3511 0H10.6667C3.85778 0 0 3.85778 0 10.6667V29.3333C0 36.1422 3.85778 40 10.6667 40H29.3511C36.16 40 40 36.1422 40 29.3333V10.6667C40 3.85778 36.16 0 29.3511 0Z",
    fill: "#913BFF",
    fillOpacity: 0.27
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7373 14.738C9.83065 14.738 9.08398 15.4846 9.08398 16.4091V30.1513C9.08398 31.058 9.83065 31.8046 10.7373 31.8046C11.6618 31.8046 12.4084 31.058 12.4084 30.1513V16.4091C12.4084 15.4846 11.6618 14.738 10.7373 14.738Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0703 8.17795C19.1637 8.17795 18.417 8.92461 18.417 9.84906V30.1513C18.417 31.0579 19.1637 31.8046 20.0703 31.8046C20.9948 31.8046 21.7414 31.0579 21.7414 30.1513V9.84906C21.7414 8.92461 20.9948 8.17795 20.0703 8.17795Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2795 21.9913C28.3551 21.9913 27.6084 22.738 27.6084 23.6624V30.1513C27.6084 31.058 28.3551 31.8046 29.2617 31.8046C30.1862 31.8046 30.9328 31.058 30.9328 30.1513V23.6624C30.9328 22.738 30.1862 21.9913 29.2795 21.9913Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon39);
export default __webpack_public_path__ + "static/media/icon_39.c9de1f2522d56e5d30eed485edd1a50e.svg";
export { ForwardRef as ReactComponent };